exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".manual-execution-parameters-description {\n  margin-top: 20px;\n}\n.notifications-list {\n  font-size: 90%;\n  padding-top: 7px;\n  text-align: left;\n}\n.notifications-list ul {\n  list-style-type: none;\n  padding-left: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/pipeline/manualExecution/manualPipelineExecution.less
// module id = 3072
// module chunks = 0